 //loader.interceptor.ts
 import { Component, OnInit, ElementRef } from '@angular/core';
 import { LoaderService } from '../_services/loader.service';
 import { environment } from '../../environments/environment';
 @Component({
   selector: 'app-loader',
   templateUrl: './loader.component.html',
   styleUrls: ['./loader.component.scss']
 })
 export class LoaderComponent implements OnInit {
  private data:any;
  public loading = {
    step:'one',
    status:'disable',
    active: false
  };
  private queries = {
     start:1,
     end:1
  }
  constructor(
    private loaderService: LoaderService,
    private elementRef:ElementRef
  ){
     this.loaderService.isLoading.subscribe((v) => {
      this.data = v;
      if(v == true){
        this.loading.status= 'enable';
        this.loading.active = true;
        this.startAnimation();
       }else if(v == false){
        this.loading.active = true;
        if(this.loading.step == 'two'){
          setTimeout(() => {
            this.loading.status= 'disable';
            this.activeEnd();
          },100)
        }
        this.activeEnd();
       }
     });
  }
  activeEnd(){
    if(this.loading.status == 'disable' && this.loading.step == 'two' && this.queries.end == 1){
      this.queries.end++
      this.endAnimation();
    }
  }
  startAnimation(){
    if(this.loading.status == 'enable' && this.loading.step == 'one' && this.queries.start == 1){
      this.queries.start++
      setTimeout(() => {
        let el = this.elementRef.nativeElement.querySelector('.start.loading-animation')
        if(el){
          el.addEventListener('animationend', this.changeAnimation());
        }else{
          this.changeAnimation()
        }
      },200)
    }
  }
  changeAnimation(){
    this.loading.step = 'two';
    this.activeEnd();
  }
  endAnimation(){
    if(this.loading.status == 'disable' &&  this.loading.step == 'two'){
      setTimeout(() => {
        this.loading.active = false;
        let el = this.elementRef.nativeElement.querySelector('.end .four')
        if(el){
          el.addEventListener('animationend',this.disableAnimation());
        }else{
          this.disableAnimation();
        }
      },1000)
    }
  }
  disableAnimation(){
    this.loading = {
      step:'one',
      status:'disable',
      active: false
    };
    this.queries = {
      start:1,
      end:1
    }
  }
  ngOnInit() {
  }
}
